module.exports = __webpack_public_path__ + "models/scene3adults.a44b95e.txt";